var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2389 5.1991L10.4264 0.386602C10.3298 0.289875 10.1987 0.235472 10.062 0.235352H1.81201C1.49292 0.235352 1.1869 0.362109 0.961274 0.587739C0.735644 0.813368 0.608887 1.11939 0.608887 1.43848V16.5635C0.608887 16.8826 0.735644 17.1886 0.961274 17.4142C1.1869 17.6398 1.49292 17.7666 1.81201 17.7666H14.187C14.5061 17.7666 14.8121 17.6398 15.0377 17.4142C15.2634 17.1886 15.3901 16.8826 15.3901 16.5635V5.56348C15.39 5.42677 15.3356 5.29571 15.2389 5.1991ZM10.5776 1.99535L13.6301 5.04785H10.5776V1.99535ZM14.187 16.7353H1.81201C1.76643 16.7353 1.72271 16.7172 1.69048 16.685C1.65824 16.6528 1.64014 16.6091 1.64014 16.5635V1.43848C1.64014 1.39289 1.65824 1.34918 1.69048 1.31694C1.72271 1.28471 1.76643 1.2666 1.81201 1.2666H9.54639V5.56348C9.54639 5.70023 9.60071 5.83138 9.69741 5.92808C9.79411 6.02478 9.92526 6.0791 10.062 6.0791H14.3589V16.5635C14.3589 16.6091 14.3408 16.6528 14.3085 16.685C14.2763 16.7172 14.2326 16.7353 14.187 16.7353Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageicon);
export default __webpack_public_path__ + "static/media/pageicon.2d227ada3af87eefdce7a682a0066dd4.svg";
export { ForwardRef as ReactComponent };